export interface NavLinkItem {
  title: string;
  href: string;
  badge?: string;
  tag?: string;
}

export interface NavSubGroup {
  title: string;
  href: string;
  badge?: string;
  items: NavLinkItem[];
}

export interface MegaMenuBlock {
  id: string;
  number: string;
  title: string;
  href: string;
  tagline: string;
  directItems?: NavLinkItem[];
  subGroups?: NavSubGroup[];
}

export interface NavMainItem {
  label: string;
  href: string;
  type: "link" | "megamenu-uslugi" | "dropdown-event";
  badge?: string;
}

export const MAIN_NAV_ITEMS: NavMainItem[] = [
  { label: "Каталог", href: "/uslugi/", type: "megamenu-uslugi" },
  { label: "Оформление мероприятий", href: "/event/", type: "dropdown-event"},
  { label: "Портфолио", href: "/portfolio/", type: "link" },
  { label: "О нас", href: "/o-kompanii/", type: "link" },
  { label: "Как заказать", href: "/kak-rabotaem/", type: "link" },
  { label: "Контакты", href: "/kontakty/", type: "link" },
];

export const USLUGI_MEGA_MENU: MegaMenuBlock[] = [
  {
    id: "naruzhnaya-reklama",
    number: "01",
    title: "Наружная реклама",
    href: "/naruzhnaya-reklama/",
    tagline: "Вывески и световые конструкции",
    directItems: [
      { title: "Изготовление вывесок", href: "/naruzhnaya-reklama/vyveski/" },
      { title: "Объёмные буквы", href: "/naruzhnaya-reklama/obemnye-bukvy/" },
      { title: "Световые короба", href: "/naruzhnaya-reklama/svetovye-koroba/" },
      { title: "Неоновые вывески", href: "/naruzhnaya-reklama/neon/" },
      { title: "Штендеры", href: "/naruzhnaya-reklama/shtendery/" },
    ],
  },
  {
    id: "pechat",
    number: "02",
    title: "Печать и полиграфия",
    href: "/pechat/",
    tagline: "Широкий формат и цифровая печать",
    directItems: [
      { title: "Широкоформатная печать", href: "/pechat/shirokoformatnaya/" },
      { title: "Печать баннеров", href: "/pechat/bannery/" },
      { title: "Наклейки и стикеры", href: "/pechat/nakleyki/" },
      { title: "Печать на холсте", href: "/pechat/holst/" },
      { title: "Печать фотографий", href: "/pechat/fotografii/" },
    ],
    subGroups: [
      {
        title: "Полиграфия",
        href: "/pechat/poligrafiya/",
        badge: "Тиражи от 50 шт",
        items: [
          { title: "Визитки", href: "/pechat/poligrafiya/vizitki/" },
          { title: "Листовки и флаеры", href: "/pechat/poligrafiya/listovki/" },
          { title: "Буклеты", href: "/pechat/poligrafiya/buklety/" },
          { title: "Дисконтные карты", href: "/pechat/poligrafiya/karty/" },
          { title: "Постеры и плакаты", href: "/pechat/poligrafiya/plakaty/" },
        ],
      },
    ],
  },
  {
    id: "tablichki-stendy",
    number: "03",
    title: "Таблички и стенды",
    href: "/tablichki/",
    tagline: "Навигация и выставочное оборудование",
    subGroups: [
      {
        title: "Таблички и навигация",
        href: "/tablichki/",
        items: [
          { title: "Офисные и информационные", href: "/tablichki/ofisnye/" },
          { title: "Адресные указатели", href: "/tablichki/adresnye/" },
          { title: "Указатели и навигация", href: "/tablichki/navigaciya/" },
          { title: "Режим работы", href: "/tablichki/rezhim-raboty/" },
          { title: "Бейджи", href: "/tablichki/bejdzhi/" },
          { title: "Планы эвакуации", href: "/tablichki/plany-evakuacii/" },
        ],
      },
      {
        title: "Стенды",
        href: "/stendy/",
        items: [
          { title: "Информационные и уголки потребителя", href: "/stendy/informacionnye/" },
          { title: "Стенды для школ и детсадов", href: "/stendy/dlya-obrazovaniya/" },
          { title: "Ролл-апы и X-баннеры", href: "/stendy/mobilnye/" },
        ],
      },
    ],
  },
  {
    id: "brendirovanie-proizvodstvo",
    number: "04",
    title: "Брендирование и цех",
    href: "/brendirovanie/",
    tagline: "Фирменный стиль и производство",
    subGroups: [
      {
        title: "Брендирование и оформление",
        href: "/brendirovanie/",
        items: [
          { title: "Брендирование транспорта", href: "/brendirovanie/transport/" },
          { title: "Оформление витрин и прилавков", href: "/brendirovanie/vitriny/" },
          { title: "Печать и надписи на одежде", href: "/brendirovanie/odezhda/" },
          { title: "Номера ГИМС на лодку", href: "/brendirovanie/nomera-gims/" },
        ],
      },
      {
        title: "Производственные услуги",
        href: "/proizvodstvennye-uslugi/",
        items: [
          { title: "Дизайн рекламных макетов", href: "/proizvodstvennye-uslugi/dizajn/" },
          { title: "Монтаж и ремонт рекламы", href: "/proizvodstvennye-uslugi/montazh-remont/" },
          { title: "Фрезеровка и лазерная резка", href: "/proizvodstvennye-uslugi/rezka/" },
          { title: "Плоттерная резка", href: "/proizvodstvennye-uslugi/plotternaya-rezka/" },
          { title: "Согласование вывесок", href: "/proizvodstvennye-uslugi/soglasovanie/" },
          { title: "Трафареты", href: "/proizvodstvennye-uslugi/trafarety/" },
          { title: "Печати и штампы", href: "/proizvodstvennye-uslugi/pechati-shtampy/" },
        ],
      },
    ],
  },
];

export const EVENT_DROPDOWN_ITEMS: NavLinkItem[] = [
  { title: "Фотозоны", href: "/event/fotozony/" },
  { title: "Пресс-воллы и бренд-воллы", href: "/event/press-volly/" },
  { title: "Декорации и оформление сцены", href: "/event/dekoracii-sceny/" },
  { title: "Оформление зала и площадки", href: "/event/oformlenie-zala/" },
  { title: "Выставочные и промо-конструкции", href: "/event/vystavochnye-konstrukcii/" },
  { title: "Входные арки и welcome-зоны", href: "/event/vhodnye-gruppy/" },
  { title: "Стойки регистрации", href: "/event/stojki/" },
  { title: "Объёмные фигуры, буквы и арт-объекты", href: "/event/obemnye-konstrukcii/" },
  { title: "Навигация и брендирование мероприятий", href: "/event/navigaciya/" },
  { title: "Праздничное и сезонное оформление", href: "/event/prazdnichnoe-oformlenie/" },
  { title: "Монтаж и демонтаж конструкций", href: "/event/montazh/" },
];
